import {Component, OnDestroy, OnInit} from '@angular/core';
import {of, Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {UtilsService} from '../../core/utils/utils.service';
import {UniteDeProductionDTO} from '../../core/dtos/unite-de-production-dto';
import {Auth2Service} from '../../core/services/security/auth2.service';
import {catchError, switchMap} from 'rxjs/operators';
import {MenuItem} from 'primeng/api';
import {ItemNavigationService} from '../../core/services/technique/item-navigation.service';

@Component({
    selector: 'yo-unite-production',
    templateUrl: './unite-production.component.html',
    styleUrls: ['./unite-production.component.scss'],
    standalone: false
})
export class UniteProductionComponent implements OnInit, OnDestroy {

  subscriptionRoute: Subscription;
  subActiveSecondaryRoute: Subscription;
  uniteDeProduction: UniteDeProductionDTO;
  tabMenuUdp: MenuItem[] = [];
  tabSelectedMenuUdp: MenuItem;
  tabMenuUpDx: any[] = [];
  tabSelectedMenuUpDx: any;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private titleSvc: Title,
              private auth2Svc: Auth2Service,
              private itemNavSvc: ItemNavigationService,
              private utils: UtilsService
              ) {
  }


  ngOnInit() {

    this.routeSubscription();

    // fix kjlnhjk tabmenu route
    this.activeSecondaryRouteSubscription();
  }

  routeSubscription() {
    this.subscriptionRoute = this.route.data.pipe(
      switchMap(data => {
        console.log(data)

        this.uniteDeProduction = data.uniteDeProductionSupplier.uniteDeProduction;
        this.titleSvc.setTitle(this.uniteDeProduction && this.uniteDeProduction.libelle);
        return this.auth2Svc.hasUniteDeProduction$;
      }),
      switchMap(data => {
        this.initTabMenuUdp();

        return of(null);
      }),
      catchError(err => this.utils.handleError(err))
    )
      .subscribe();
  }

  initTabMenuUdp() {
    this.tabMenuUdp = [];

    if (this.utils.isNumberGt0(this.uniteDeProduction.id)) {

      this.auth2Svc.hasUniteDeProduction$.subscribe((response: boolean) => {
        if (response) {
          this.tabMenuUdp.push({label: `Fiche d'identité`, routerLink: ['ficheidentite']});
          this.syncDxTabs();
        }
      });
      this.auth2Svc.hasUniteDeProductionLiv$.subscribe((response: boolean) => {
        if (response) {
          this.tabMenuUdp.push({label: `Livraisons`, routerLink: ['livraisons']});
          this.syncDxTabs();
        }
      });
      this.auth2Svc.hasUniteDeProductionArticlesPreferes$.subscribe((response: boolean) => {
        if (response) {
          this.tabMenuUdp.push({label: `Articles préférés`, routerLink: ['articles-preferes/grille']});
          this.syncDxTabs();
        }
      });
      this.auth2Svc.hasUniteDeProductionEquipes$.subscribe((response: boolean) => {
        if (response) {
          this.tabMenuUdp.push({label: `Equipes`, routerLink: ['equipes']});
          this.syncDxTabs();
        }
      });

      this.auth2Svc.hasUniteDeProductionStocks$.subscribe((response: boolean) => {
        if (response) {
          this.tabMenuUdp.push({label: `Stocks`, routerLink: ['zonesDeStockage']});
          this.syncDxTabs();
        }
      });
      this.auth2Svc.hasUniteDeProductionDenreesInterdites$.subscribe((response: boolean) => {
        if (response) {
          this.tabMenuUdp.push({label: `Déclinaisons interdites`, routerLink: ['denreesInterdites', 'grille']});
          this.syncDxTabs();
        }
      });

      this.auth2Svc.hasGestionIDistri$.subscribe((response: boolean) => {
        if (response) {
          this.tabMenuUdp.push({label: `Conditionnement`, routerLink: ['conditionnement']});
          this.syncDxTabs();
        }
      });
      this.auth2Svc.hasUniteDeProduction$.subscribe((response: boolean) => {
        if (response) {
          this.tabMenuUdp.push({label: `Incohérences`, routerLink: ['incoherences']});
          this.syncDxTabs();
        }
      });
      this.auth2Svc.hasUniteDeProduction$.subscribe((response: boolean) => {
        if (response) {
          this.tabMenuUdp.push({label: `Déclinaisons sans appro`, routerLink: ['produits-declinaisons-non-approvisionnes']});
          this.syncDxTabs();
        }
      });
      this.auth2Svc.hasUniteDeProduction$.subscribe((response: boolean) => {
        if (response) {
          this.tabMenuUdp.push({label: `Fermetures Ponctuelles`, routerLink: ['fermetures-ponctuelles']});
          this.syncDxTabs();
        }
      });
      this.auth2Svc.hasUniteDeProduction$.subscribe((response: boolean) => {
        if (response) {
          this.tabMenuUdp.push({label: `Pondération des repas`, routerLink: ['repas-ponderation']});
        }
      });
    }


    this.syncDxTabs();

  }


  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subscriptionRoute);
  }

  activeSecondaryRouteSubscription() {
    this.subActiveSecondaryRoute = this.itemNavSvc.secondaryRoute$.subscribe(event => {
      this.tabSelectedMenuUdp = this.itemNavSvc.activeSecondaryRoute(event, this.tabMenuUdp);
      this.tabSelectedMenuUpDx = this.tabMenuUpDx.find(tab => tab.label === this.tabSelectedMenuUdp?.label) || this.tabMenuUpDx[0];
    });
  }

  goToTabUdp = (event: any) : void => {
    const item = event?.itemData;
    if (!item) return;

    this.tabSelectedMenuUdp = this.tabMenuUdp.find(tab => tab.label === item.label) || item;
    this.tabSelectedMenuUpDx = item;

    if (item.routerLink) {
      this.router.navigate(item.routerLink as any[], {relativeTo: this.route});
    }
  };

  // Synchronise la liste d'onglets DevExtreme et l'onglet actif à partir du menu existant,
  // car tabMenuUdp est alimenté progressivement via plusieurs subscribe.
  private syncDxTabs(): void {
    this.tabMenuUpDx = this.tabMenuUdp.map(item => ({
      ...item,
      text: item.label
    }));

    this.tabSelectedMenuUpDx =
      this.tabMenuUpDx.find(tab => tab.label === this.tabSelectedMenuUdp?.label) || this.tabMenuUpDx[0];
  }

}
